import React from 'react'
import {
    RiEyeLine,
    RiMailLine,
    RiMapPinLine,
    RiPhoneLine,
} from 'react-icons/ri';
import { Link } from 'react-router-dom';

const ParticipantCard = ({
    firstName,
    lastName,
    email,
    phone,
    gender,
    datasetID,
    country,
    state,
    city,
    _id,
}) => {
    const initials =
        `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase();
    const fullName = [firstName, lastName].filter(Boolean).join(' ');
    const isFemale = gender?.value === 2;
    const phoneStr = phone ? `${phone?.countryCode} ${phone?.number}` : null;
    const locationStr = [city, state?.label, country?.label]
        .filter(Boolean)
        .join(', ');
    return (
        <div className="w-full space-y-2 p-3 ">
            {/* Header */}
            <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center text-white font-semibold text-sm flex-shrink-0">
                    {initials || '?'}
                </div>

                <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-900 truncate">
                        {fullName || '—'}
                    </p>
                    <p className="text-xs font-medium text-blue-500 font-mono mt-0.5">
                        UN#{datasetID}
                    </p>
                </div>

                {gender && (
                    <span
                        className={`text-xs font-medium px-2.5 py-0.5 rounded-full border flex-shrink-0 ${isFemale
                            ? 'bg-pink-50 text-pink-700 border-pink-200'
                            : 'bg-blue-50 text-blue-700 border-blue-200'
                            }`}
                    >
                        {gender.label}
                    </span>
                )}

                {/* <Link
                    to={`//my-dataset/${_id}`}
                    className="text-primary-600 cursor-pointer flex-shrink-0"
                    onClick={(e) => e.stopPropagation()}
                    target="_blank"
                >
                    <RiEyeLine size={18} />
                </Link> */}
            </div>

            <hr />

            {/* Details */}
            <div className="flex flex-col gap-2">
                <DetailRow icon={<RiMailLine size={14} />} value={email} />
                <DetailRow icon={<RiPhoneLine size={14} />} value={phoneStr} />
                {locationStr && (
                    <DetailRow icon={<RiMapPinLine size={14} />} value={locationStr} />
                )}
            </div>
        </div>
    )
}
const DetailRow = ({
    icon,
    value,
}) => {
    if (!value) return null;

    return (
        <div className="flex items-start gap-2 text-gray-500">
            <span className="mt-0.5 flex-shrink-0">{icon}</span>
            <span className="text-xs text-gray-600 leading-relaxed break-all">
                {value}
            </span>
        </div>
    );
};

export default ParticipantCard